import { useTranslation } from 'react-i18next';
import { Locale } from '@/lib/enums/locale.enum';

const useLocale = () => {
  const { i18n } = useTranslation();
  return i18n.language as Locale;
};

export default useLocale;
